module.exports = __webpack_public_path__ + "img/icon-plus.690d6ff2.svg";